<!--
 * @Author: rossdong@yntengyun.com
 * @Date: 2024-09-06 13:36:37
 * @Description: 其他变更
-->
<template>
    <div class="bg-[#F0F2F5]">
        <div class="bg-white pb-24">
            <div class="mx-16 pt-20 mb-20 text-[#54565C]">
                其他变更说明<span class="text-[#ee0a24] ml-4">*</span>
            </div>
            <div class="input-wrap bg-[#F9FAFC] mx-16 rounded-4">
                <van-field v-model="message" rows="5" type="textarea" placeholder="请输入" maxlength="500"
                    show-word-limit />
            </div>
        </div>
        <div class="h-4 bg-[#F0F2F5]"></div>
        <!-- 附件 -->
        <div class="mt-8 bg-white px-16 py-[16px]">
            <div class="text-[14] text-[#54565C] mt-16">附件(备注:支持上传pdf、word、excel、jpg、png等格式文件，仅支持20m以内的单个文件上传，最多上传3个文件。)
            </div>
            <!--  -->
            <div class="mt-16">
                <FileList removable collapsed :files.sync="fileList" :imageMax="3" :otherMax="3">
                    <template #empty="{ handleUpload }">
                        <div class="h-80 w-80" @click="handleUpload">
                            <UploadTrigger :icon-size="15" />
                        </div>
                        <!-- <div class="mt-12px text-12px text-grey-b leading-14px">
          补充图片{{
            isApp() ? '/视频/音频/文件等' : ''
          }}证据，可提高投诉处理进度
        </div> -->
                    </template>
                    <template #continue="{ handleUpload }">
                        <UploadTriggerCell color="#36B374" @click="handleUpload" />
                    </template>
                </FileList>

            </div>
        </div>

        <div class="mt-16 mx-16 rounded-8 h-40 leading-40 bg-[#36B374] alpha-0.5 text-white text-16 font-500 text-center"
            @click="onCommit" :class="[enable ? 'opacity-100' : 'opacity-50']">
            提交
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import FileList from '@/components/FilePreviewer/FileList.vue';
import UploadTrigger from '@/components/FilePreviewer/UploadTrigger.vue';
import UploadTriggerCell from '@/components/FilePreviewer/UploadTriggerCell.vue';
import { agencySaveOtherChangeDraft, reportTeamChange } from '@/service';
import { Dialog, Toast } from 'vant';
import store from '@/store';
import router from '@/router/routers';
import { useRouter } from 'vue-router/composables';


const message = ref('')

const enable = computed(() => {
    return message.value.length > 0
})
const fileList = ref([])
// const fileList = ref([
//     {
//         "type": 1,
//         "url": "https://images-1254950508.cos.ap-guangzhou.myqcloud.com/tio_file/debug/13769110016/1717061517891.jpg",
//         "original": "1717061517891.jpg",
//         "mime": "image/jpeg",
//         "size": 338098
//     },
//     {
//         "type": 1,
//         "url": "https://images-1254950508.cos.ap-guangzhou.myqcloud.com/tio_file/debug/13769110016/1717061517891.jpg",
//         "original": "1717061517891.jpg",
//         "mime": "image/jpeg",
//         "size": 338098
//     },
//     {
//         "type": 1,
//         "url": "https://images-1254950508.cos.ap-guangzhou.myqcloud.com/tio_file/debug/13769110016/1717061517891.jpg",
//         "original": "1717061517891.jpg",
//         "mime": "image/jpeg",
//         "size": 338098
//     },
//     {
//         "type": 1,
//         "url": "https://images-1254950508.cos.ap-guangzhou.myqcloud.com/tio_file/debug/13769110016/1717061517891.jpg",
//         "original": "1717061517891.jpg",
//         "mime": "image/jpeg",
//         "size": 338098
//     }
// ])

const detailInfo = computed(() => store.state.itineraryUniversal.detailInfo.value)

const navigate = useRouter()

const onCommit = async () => {
    if (!enable.value) return
    if (fileList.value.length > 3) {
        Toast.fail("最多上传3个附件")
        return
    }
    const result = await Dialog.confirm({
        message: "如您电脑端有待上报变更，本次提交将会一并提交。",
        confirmButtonText: "确认提交",
        confirmButtonColor: '#36B374'
    });


    if (result !== 'confirm') return;

    const infoMessage = detailInfo.value.itineraryInfoMessage
    try {
        Toast.loading({
            message: '加载中...',
            forbidClick: true,
        });
        const requestParams = {
            teamId: infoMessage.teamId,
            remark: message.value,
            filePath: fileList.value.map(item => item.url).join(","),
            travelId: infoMessage.travelId
        }
        const res = await agencySaveOtherChangeDraft(requestParams)
        if (res.ret == 0) {
            reportChange()
        } else {
            Toast.fail(`接口失败`);
        }

    } catch (e) {
        console.log('output->[ e ] >', e)
        Toast.fail(`接口失败`);
    }

}

// 上报
const reportChange = async () => {
    const infoMessage = detailInfo.value.itineraryInfoMessage
    const requestParams = {
        teamId: infoMessage.teamId,
    }
    const res = await reportTeamChange(requestParams)
    if (res.ret == 0) {
        res && Toast.success(`已成功`)
        router.back()
    } else {
        Toast.fail(`上报审核失败`);
    }
}

</script>

<style scoped>
::v-deep .input-wrap .van-cell {
    background-color: transparent;
}
</style>
